import React, { useEffect, useState } from "react";
import Button from "sushiweb/Button";
import Table from "../../components/Common/Table";
import MenuNames from "../../constants/Menu/MenuNames.json";
import ListPagination from "../../components/Common/ListPagination";
import MenuActionsMappings from "../../constants/Menu/MenuActionsMappings";
import Permission from "../../components/Common/Permission";
import { Heading } from "../../constants/assets/containers";
import { getPath } from "../../utils";
import * as DriverSheltersActions from "../../store/actions/DriverShelters";
import { connect } from "react-redux";
import DriverShelterModal from "../../components/DriverShelters/DriverShelterModal/index";
import { bindActionCreators } from "redux";
import { useHistory, useParams } from "react-router-dom";

// import Permission from "../../Common/Permission";
import TableFields from "../../constants/DriverShelters/TableField.json";
import { Pill, NotesSection } from "../../constants/assets/containers";

const DriverShelters = (props) => {
  const params = useParams();
  const history = useHistory();
  const allActions = MenuActionsMappings[MenuNames.DRIVER_SHELTER];
  const {
    getDriverSheltersList,
    setDriverSheltersList,
    driverSheltersList,
    prevPage,
    nextPage,
    activeFilters,
    activeDriverShelter,
  } = props;
  const shouldRenderList =
    getPath(params, "id", undefined) === undefined ? true : false;

  const [error, setError] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [modalState, setModalState] = useState(false);
  const [activeId, setActiveId] = useState();

  const handleNavClick = (action) => {
    if (action === "prev") {
      let pageRequest = {
        page: currentPage - 1,
        page_size: 10,
      };
      setCurrentPage(currentPage - 1);
      props.getDriverSheltersList(activeFilters, pageRequest);
    } else {
      let pageRequest = {
        page: currentPage + 1,
        page_size: 10,
      };
      setCurrentPage(currentPage + 1);
      props.getDriverSheltersList(activeFilters, pageRequest);
    }
  };

  const handleClick = (type, id) => {
    console.log(type);
    setModalState(type);
    setActiveId(id);
  };

  useEffect(() => {
    if (shouldRenderList) {
      getDriverSheltersList();
    } else {
      handleClick("Edit", params.id);
    }
  }, []);

  const getFieldValue = (item, key) => {
    switch (key) {
      case "actions":
        return (
          <Permission
            optionalPerms={[allActions.UPDATE, allActions.CREATE]}
            notAllowedText="No Allowed Actions"
          >
            <span
              onClick={() => history.push(`/driver-shelter/${item.shelter_id}`)}
              className={"edit-options cursor-pointer"}
            >
              View/Edit
            </span>
          </Permission>
        );
      case "is_active":
        return (
          <Pill isFalse={!item[key]}>
            {item[key] == true ? "ACTIVE" : "INACTIVE"}
          </Pill>
        );
      case "is_rest_point":
        return (
          <Pill isFalse={!item[key]}>
            {item[key] == true ? "TRUE" : "FALSE"}
          </Pill>
        );
      case "amenities":
        var text = "";
        if (item.amenities != null && item.amenities.length != 0) {
          text = item.amenities.map((amenity) => amenity.name).join(",");
        }
        return <NotesSection>{text}</NotesSection>;
      default:
        return item[key] || "Error in displaying value";
    }
  };

  const handleClose = () => {
    setModalState(false);
    history.goBack();
  };

  const getModal = () => {
    const addProps = {
      modalState: modalState,
      handleClose: handleClose,
    };

    const editProps = {
      modalState: modalState,
      activeId: activeId,
      handleClose: handleClose,
      activeDriverShelter: activeDriverShelter,
    };

    switch (modalState) {
      case "Edit":
        return <DriverShelterModal {...editProps} />;
      case "Add":
        return <DriverShelterModal {...addProps} />;
      // case "Filter":
      //   return <CityFormModal {...defaultProps} filterFields={filterFields} />;
      default:
        return;
    }
  };

  return (
    <section>
      <Heading>Driver Shelters</Heading>
      <div className="actionBar mb-20 flex items-center justify-end">
        {/* @todo need to do in next release */}
        {/*<Permission requiredPerms={[allActions.READ]}>*/}
        {/*  <FilterButton*/}
        {/*    // activeFilters={props.activeFilters}*/}
        {/*    handleClick={() => handleClick("Filter", null)}*/}
        {/*  />*/}
        {/*</Permission>*/}
        <Permission requiredPerms={[allActions.CREATE]}>
          <Button
            onClick={() => handleClick("Add", null)}
            className="sushi-btn ml-12"
            data-testid="CitiesAddBtn"
          >
            Add New
          </Button>
        </Permission>
      </div>

      <Permission requiredPerms={[allActions.READ]}>
        <Table
          list={driverSheltersList}
          fields={TableFields}
          getFieldValue={getFieldValue}
        />
        <ListPagination
          nextPage={nextPage}
          prevPage={prevPage}
          handleNavClick={handleNavClick}
        />
      </Permission>
      {modalState && getModal()}
    </section>
  );
};

const mapStateToProps = (state) => {
  const { DriverShelters } = state;
  return {
    driverSheltersList: DriverShelters.driverSheltersList,
    nextPage: DriverShelters.nextPage,
    prevPage: DriverShelters.prevPage,
    activeFilters: DriverShelters.activeFilters,
    activeDriverShelter: DriverShelters.activeDriverShelter,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getDriverSheltersList: bindActionCreators(
      DriverSheltersActions.getDriverSheltersList,
      dispatch
    ),
    setDriverSheltersList: bindActionCreators(
      DriverSheltersActions.setDriverSheltersList,
      dispatch
    ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DriverShelters);
